var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHalfStarpng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    transform: "translate(0.139648 0.630005)",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1792_263",
    transform: "scale(0.04)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1792_263",
    width: 25,
    height: 25,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAMAAADzN3VRAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAMlQTFRFIUKRgZG93Nzmp7LRJkeU6+303t7oUGqo////6OjvJUWTvMbe9vb43d3nOlie4eXw+/v84eHpYHix/P3+5+fuLEuWdIm6s77Z9fX46enwdou87/L3/f3+6+vxI0SSU22qwsvh+vv9/v7+9vb55eXsME+YgpXB7e3y39/oaoC2/f396envTWen9/f54ODpi5zG8/P3xM3i9fb6zdPk9fX3/Pz+OVedXnavpLLSQF2h8PD06OjuKUmVmKfMboO3JESS8fH1PVqf3t7nwU2EKQAAAK9JREFUeJy10dcOgkAQBVCw4EXsgopi74UVsffy/x+lQtwsCyT64H2ck92Z5AoCEzHCRPifRMMkFpdCJAE5WJIKUulAyWSRywdKoQioXtFKTsoAKroT6fOmWgMbo05/azRbbTrvdHvsnv6AynDEXTB255Op77aZAybxXz1/r7BkXfXJArCXKwMmL9oaykYkFkA42dq7/asfcjCOXjmdL1e3OfUmeUS7007J46e2v5QnY2UPZaoLW24AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfStarpng);
export default __webpack_public_path__ + "static/media/half-star.png.f1d2ffdecffe99127f6257941878ba05.svg";
export { ForwardRef as ReactComponent };